import moment from "moment"
import { MocUserRole } from "../../services/models/Enums"

export const PermissionUtils = {
  displayPatientName: function (
    userRole: any,
    patient: any,
    displayMocId: boolean,
    prefix: any = null,
    suffix: any = null
  ) {
    const name =
      userRole === MocUserRole.PATIENT
        ? patient?.name
        : patient?.isVIP
        ? displayMocId
          ? patient?.mocId
          : ""
        : patient?.name || patient?.patientName
    return `${prefix && name ? prefix : ""} ${name ? name : ""} ${
      name && suffix ? suffix : ""
    }`
  },

  maskName: function (userRole: any, patient: any) {
    return userRole !== MocUserRole.PATIENT ? patient?.isVIP : true
  },

  isAfter48hours: function (scheduleDate: any) {
    const timeDiff = moment(new Date()).diff(scheduleDate, "hours")
    return timeDiff > 48
  },
}

export default PermissionUtils
